export function Upcoming() {
  return (
    <div className="upcoming-container">
      <div className="upcoming-message">
        For upcoming release dates, see{" "}
        <a href="http://go/firebase-sdk-dates" rel="noreferrer" target="_blank">
          go/firebase-sdk-dates
        </a>
      </div>
    </div>
  );
}
